var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

function IconTrashCan(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 4c0-.966.784-1.75 1.75-1.75h4c.966 0 1.75.784 1.75 1.75v.75h2.75a.75.75 0 01.234 1.463l-.834 9.515v.002a2.75 2.75 0 01-2.74 2.52H6.84a2.75 2.75 0 01-2.74-2.52v-.002l-.834-9.515A.75.75 0 013.5 4.75h2.75V4zm1.5.75h4.5V4a.25.25 0 00-.25-.25H8a.25.25 0 00-.25.25v.75zm-2.975 1.5l.82 9.354A1.25 1.25 0 006.84 16.75h6.32a1.25 1.25 0 001.245-1.146V15.6l.82-9.351H4.775zM8.25 8a.75.75 0 01.75.75v5.5a.75.75 0 01-1.5 0v-5.5A.75.75 0 018.25 8zm3.5 0a.75.75 0 01.75.75v5.5a.75.75 0 01-1.5 0v-5.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}

export default IconTrashCan;